import { Route } from '@angular/router';
const redirectPath = true ? 'five-day' : 'day';

export const CALENDAR_ROUTES: Route[] = [
    {
        path: '',
        redirectTo: redirectPath,
        pathMatch: 'full',
    },
    {
        path: 'day',
        loadComponent: () => import('./components/day/day.component').then((comp) => comp.CalendarDayComponent),
        data: {
            viewType: 'day'
        },
    },
    {
        path: 'day/:date',
        loadComponent: () => import('./components/day/day.component').then((comp) => comp.CalendarDayComponent),
        data: {
            viewType: 'day'
        },
    },
    {
        path: 'five-day',
        loadComponent: () => import('./components/five-day/five-day.component').then((comp) => comp.CalendarFiveDayComponent),
        data: {
            viewType: 'five-day'
        },
    },
    {
        path: 'five-day/:date',
        loadComponent: () => import('./components/five-day/five-day.component').then((comp) => comp.CalendarFiveDayComponent),
        data: {
            viewType: 'five-day'
        },
    },
];
